import React from 'react'

type Props = React.ComponentProps<'svg'>

export const ArrowRightBold: React.FC<Props> = (props) => (
  <svg
    width="13"
    height="20"
    viewBox="0 0 13 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.32266 0.591585L12.3227 8.57968C12.7164 9.0259 12.9102 9.54127 12.9102 10.0001C12.9102 10.4589 12.7148 11.0295 12.3242 11.4223L4.32422 19.4104C3.75197 19.9859 2.89234 20.1583 2.14422 19.8468C1.39609 19.5352 0.910156 18.912 0.910156 18.0447V2.01197C0.910156 1.1987 1.39647 0.46463 2.14453 0.152899C2.89259 -0.158831 3.75391 0.0152602 4.32266 0.591585Z"
      fill="inherit"
    />
  </svg>
)
